import React from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  Container,
  Divider,
  Link,
} from "@chakra-ui/react";
import Footer from "../components/layout/footer";

const RefundPolicyPage: React.FC = () => {
  return (
    <Container maxW="container.md" py={10} flexDirection={"column"}>
      <VStack spacing={6} align="start">
        <Heading as="h1" size="2xl">
          Refund & Cancellation Policy
        </Heading>

        <Text fontSize="sm" color="gray.500">
          Last Updated: 28 August 2025 
          <br />
          Company: Sale Radius
        </Text>

        <Divider />

        <Box>
          <Heading as="h2" size="lg" mb={2}>
            1. Subscription Billing
          </Heading>
          <Text>
            All subscriptions for our SaaS platform are billed through{" "}
            <strong>Paddle</strong>, which acts as the Merchant of Record. Subscriptions are available on a monthly or annual basis, depending on the plan selected.
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={2}>
            2. Cancellation
          </Heading>
          <Text>
            You may cancel your subscription at any time through the{" "}
            <Link
              color="blue.500"
              href="https://my.paddle.com/"
              isExternal
            >
              Paddle Customer Portal
            </Link>
            . Once canceled, your subscription will remain active until the end of the current billing period. No additional charges will be applied after cancellation takes effect.
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={2}>
            3. Refunds
          </Heading>
          <Text>
            Refund requests are handled in accordance with <strong>Paddle’s refund policy</strong>. To request a refund, please contact us at{" "}
            <Link color="blue.500" href="mailto:email@example.com">
              email@example.com
            </Link>{" "}
            with your Paddle transaction ID. Refund eligibility is determined by Paddle and may vary depending on your subscription duration, usage, and payment method.
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={2}>
            4. Billing Disputes
          </Heading>
          <Text>
            All billing disputes must be submitted through{" "}
            <Link
              color="blue.500"
              href="https://paddle.com/support/"
              isExternal
            >
              Paddle’s support channels
            </Link>
            . We are available to assist with questions or clarifications, but final resolution is managed by Paddle as the Merchant of Record.
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={2}>
            5. Important Notes
          </Heading>
          <Text>
            We do not provide direct refunds outside of Paddle, as all transactions are processed through their platform. Please ensure your account information and payment details are correct to avoid unnecessary billing issues. Users are responsible for managing their subscription via the Paddle Customer Portal.
          </Text>
        </Box>

        <Divider />

        <Box>
          <Heading as="h2" size="lg" mb={2}>
            Contact Us
          </Heading>
          <Text>
            If you have questions regarding refunds or cancellations, please contact: <br />
            <strong>Email:</strong>{" "}
            <Link color="blue.500" href="mailto:email@example.com">
              email@example.com
            </Link>
            <br />
            <strong>Website:</strong>{" "}
            <Link color="blue.500" href="https://www.saleradius.com" isExternal>
              www.saleradius.com
            </Link>
          </Text>
        </Box>
      </VStack>
      <Footer />
    </Container>
  );
};

export default RefundPolicyPage;
